const InProgress = 1;
const ReadyForOrder = 2;
const Ordered = 3;
const Offer = 4

export default {
    InProgress: InProgress,
    ReadyForOrder: ReadyForOrder,
    Ordered: Ordered,
    Offer: Offer
}